import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { UpdateMeterArg, UpdateMeterResponse } from 'lib/services';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';
import { getErrorMessage } from 'utils/getErrorMessage';

export const useUpdateMeter = (): UseMutationResult<UpdateMeterResponse, unknown, UpdateMeterArg> => {
  const notify = useAppNotifications();
  const queryClient = useQueryClient();
  const {
    backendGateway: { meters },
  } = useServices();

  return useMutation({
    mutationFn: async (args: UpdateMeterArg) => await meters.update(args),
    mutationKey: MUTATION_KEYS.meters.updateOne(),
    onError: error => {
      notify.error({
        message: 'There was an error while updating meter',
        description: getErrorMessage(error),
      });
    },
    onSuccess: () => {
      notify.success({
        message: `Meter updated`,
      });
      queryClient.invalidateQueries(QUERY_KEYS.meters.all());
    },
  });
};
